<template>
  <ion-header class="ion-no-border">
    <ion-toolbar class="-not-fixed">
      <!-- <ion-title>{{ title ? title : "Information" }}</ion-title> -->
      <ion-buttons slot="end">
        <ion-button @click="modalController.dismiss()"
          ><ion-icon slot="icon-only" :icon="close"
        /></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content ref="content" class="ion-padding">
    <img
      v-if="showImage"
      :src="imagePath || require('@lib/assets/img/tips/default.png')"
      class="ion-margin-bottom c-info-modal__image" />
    <h6>
      <b>{{ title !== null ? title : "Information" }}</b>
    </h6>
    <div v-html="text"></div>
    <div class="ion-text-center ion-margin-top ion-padding-top">
      <ion-button fill="outline" @click="modalController.dismiss()">{{
        closeText
      }}</ion-button>
    </div>
  </ion-content>
  <!-- <ion-footer class="ion-no-border">
    <ion-button
      fill="outline"
      expand="block"
      @click="modalController.dismiss()"
      >{{ closeText }}</ion-button
    >
  </ion-footer> -->
</template>

<script>
import { close } from "ionicons/icons";
import {
  modalController,
  // IonTitle,
  IonHeader,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonContent,
  // IonFooter,
} from "@ionic/vue";

export default {
  components: {
    // IonTitle,
    IonHeader,
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonContent,
    // IonFooter,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    imagePath: {
      type: String,
      required: false,
      default: "",
    },
    showImage: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    closeText: {
      type: String,
      required: false,
      default: "Schließen",
    },
  },
  data() {
    return {
      modalController: modalController,
    };
  },
  setup() {
    return { close };
  },
};
</script>

<style lang="scss" scoped>
.c-info-modal {
  &__image {
    max-width: 250px;
  }
}
</style>
